(function() {
  // Helper to parse any solid CSS color value to RGB components using browser engine
  function parseColor(colorStr) {
    if (!colorStr) return null;
    // Gradients are not single colors and cannot be parsed into R, G, B components
    if (colorStr.includes('gradient')) return null;

    const tempEl = document.createElement('div');
    tempEl.style.color = colorStr.trim();
    document.body.appendChild(tempEl);
    const computedColor = window.getComputedStyle(tempEl).color;
    document.body.removeChild(tempEl);

    const match = computedColor.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/);
    if (match) {
      return {
        r: parseInt(match[1], 10),
        g: parseInt(match[2], 10),
        b: parseInt(match[3], 10),
        rgbStr: `rgb(${match[1]}, ${match[2]}, ${match[3]})`
      };
    }
    return null;
  }

  document.addEventListener("DOMContentLoaded", function() {
    // Process color swatches
    document.querySelectorAll('.color-card').forEach(function(card) {
      const rawColor = card.getAttribute('data-raw-color');
      const rgbEl = card.querySelector('.overlay-rgb');
      const copyLabel = card.querySelector('.overlay-copy-icon span');

      if (!rawColor) return;

      if (rawColor.includes('gradient')) {
        // Gradient case
        if (rgbEl) {
          rgbEl.textContent = 'CSS Background';
          rgbEl.setAttribute('data-copy-val', rawColor);
        }
        if (copyLabel) copyLabel.textContent = 'Copy Gradient';
      } else {
        // Solid color case
        const parsed = parseColor(rawColor);
        if (parsed) {
          if (rgbEl) {
            rgbEl.textContent = parsed.rgbStr;
            rgbEl.setAttribute('data-copy-val', parsed.rgbStr);
          }
          if (copyLabel) copyLabel.textContent = 'Copy RGB';
        } else {
          if (rgbEl) {
            rgbEl.textContent = '';
            rgbEl.setAttribute('data-copy-val', rawColor);
          }
          if (copyLabel) copyLabel.textContent = 'Copy Color';
        }
      }
    });
  });

  // Global copy notification function
  window.showToastNotification = function(message) {
    let toast = document.querySelector('.color-chart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'color-chart-toast';
      toast.innerHTML = `
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span class="toast-message"></span>
      `;
      document.body.appendChild(toast);
    }
    toast.querySelector('.toast-message').textContent = message;
    toast.classList.add('show');
    setTimeout(() => {
      toast.classList.remove('show');
    }, 2500);
  };

  // Copy RGB or Gradient CSS value of the clicked swatch card container to clipboard
  window.copyColorRgb = function(container) {
    const rgbEl = container.querySelector('.overlay-rgb');
    if (rgbEl) {
      const copyVal = rgbEl.getAttribute('data-copy-val') || rgbEl.textContent;
      navigator.clipboard.writeText(copyVal).then(function() {
        window.showToastNotification(`Copied to clipboard!`);
      }).catch(function(err) {
        console.error('Failed to copy color: ', err);
      });
    }
  };
})();
